export default __webpack_public_path__ + "static/media/mandatory-design-three-resize.308a1650.png";